import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.parse-int.js";
import { fhtStorage } from "@/pages/base/fhtStorage";
import "./index.scss";
import feigePng from "@/pages/Images/MobilePopAds/feige.png";
import feigeLiandongPng from "@/pages/Images/MobilePopAds/feige liandong.png";
import iosPng from "@/pages/Images/MobilePopAds/ios.png";
import androidPng from "@/pages/Images/MobilePopAds/android.png";
import { QRCODE_PATH, fhtCommonEnv } from "@/common/fhtGlobalEnv";
import { UrlHelperExtensions } from "@/url_helpers";
import { ProductAndServiceMenuTypeEnum } from "@/apis/model/ProductAndServiceMenuTypeEnum";
var ui = "\n<div class=\"mobile-pop-ads\">\n    <div class=\"mobile-pop-ads__inner\">\n        <div class=\"mobile-pop-ads__feige\">\n            <img src=\"" + feigePng + "\" alt=\"feige liandong\" />\n            <div class=\"mobile-pop-ads__feige-note-wrapper\">\n                <img src=\"" + feigeLiandongPng + "\" alt=\"\u98DE\u9E3D\u8054\u52A8\" />\n                <span class=\"mobile-pop-ads__feige-note\">\u63D0\u4F9B\u5EFA\u7AD9\u3001\u53D1\u5E03\u4FE1\u606F\u3001\u5546\u4E1A\u793E\u4EA4\u3001\u6316\u6398\u5546\u673A</span>\n            </div>\n        </div>\n        <a href=\"" + UrlHelperExtensions.$OfficialSiteProductUrl(ProductAndServiceMenuTypeEnum.AppDownload, undefined) + "\" class=\"mobile-pop-ads__app\">\n            <img src=\"" + iosPng + "\" alt=\"ios download\" />\n            <span class=\"mobile-pop-ads__note\">App Store\u4E0B\u8F7D</span>\n        </a>\n        <a href=\"" + UrlHelperExtensions.$OfficialSiteProductUrl(ProductAndServiceMenuTypeEnum.AppDownload, undefined) + "\" class=\"mobile-pop-ads__app\">\n            <img src=\"" + androidPng + "\" alt=\"android download\" />\n            <span class=\"mobile-pop-ads__note\">\u5B89\u5353\u5E94\u7528\u5E02\u573A\u4E0B\u8F7D</span>\n        </a>\n        <div class=\"mobile-pop-ads__qrcode-wrapper\">\n            <img src=\"" + QRCODE_PATH + "\" />\n        </div>\n        <span class=\"mobile-pop-ads__close\" title=\"\u5173\u95ED\u540E7\u5929\u5185\u5C06\u4E0D\u518D\u663E\u793A\"></span>\n    </div>\n    <div></div>\n</div>\n";
$(function () {
  function getExpirableActionManager(actionName, expirySeconds) {
    if (expirySeconds === void 0) {
      expirySeconds = 7 * 24 * 3600;
    }

    var key = "action_" + actionName + "_ts";
    var expiryInterval = expirySeconds * 1000;

    if (fhtCommonEnv.DEBUG) {
      expiryInterval = 5 * 1000;
    } else if (fhtCommonEnv.AppEnv !== "Production") {
      expiryInterval = 60 * 1000;
    }

    return {
      saveActionValue: function saveActionValue() {
        fhtStorage.setItem(key, new Date().getTime().toString());
      },
      isStillEffective: function isStillEffective() {
        var $d = $.Deferred();
        fhtStorage.getItem(key).then(function (savedTimestamp) {
          if (savedTimestamp) {
            var value = parseInt(savedTimestamp, 10);

            if (value) {
              var d = new Date(value);
              var isEffective = new Date().getTime() - d.getTime() < expiryInterval;
              $d.resolve(isEffective);
              return;
            }
          }

          $d.resolve(false);
        });
        return $d;
      }
    };
  }

  var userActionManager = getExpirableActionManager("mobilePopAdsClosed");
  userActionManager.isStillEffective().done(function (isEffective) {
    if (!isEffective) {
      var $ads_1 = $(ui).appendTo(document.body).hide().fadeIn(200);
      $ads_1.on("click", ".mobile-pop-ads__close", function () {
        $ads_1.remove();
        userActionManager.saveActionValue();
      });
    }
  });
});